export const testAttributes = {
    FEATURED_IMAGE_CONTAINER: 'featured_image_container',
    FEATURED_IMAGE_SOURCE: 'featured_image_source'

}